export default {
  "orders.title": "الطلبات",
  "orders.subtitle": "متابعة الطلبات من القبول حتى اكتمال الاستلام",

  "orders.tab.new": "الجديدة",
  "orders.tab.active": "الجارية",
  "orders.tab.completed": "المكتملة",
  "orders.tab.cancelled": "الملغاة",

  "orders.col.order": "رقم الطلب",
  "orders.col.customer": "العميل",
  "orders.col.priority": "الأولوية",
  "orders.col.fulfillment": "الاستلام والتسليم",
  "orders.col.total": "المبلغ الإجمالي",
  "orders.col.status": "الحالة",
  "orders.col.actions": "إجراء",

  "orders.empty.new": "لا توجد طلبات جديدة بانتظار القبول",
  "orders.empty.active": "لا توجد طلبات جارية حاليًا",
  "orders.empty.completed": "لا توجد طلبات مكتملة",
  "orders.empty.cancelled": "لا توجد طلبات ملغاة",
  "orders.error": "تعذّر تحميل الطلبات",
  "orders.errorDetail": "تعذّر تحميل تفاصيل الطلب",
  "orders.errorAction": "تعذّر تنفيذ الإجراء، حاول مرة أخرى.",
  "orders.stateChanged": "تغيّرت حالة الطلب. تم تحديث البيانات.",
  "orders.notFound": "تعذّر العثور على الطلب أو أنه لا يتبع مغسلتك.",
  "orders.notFoundBack": "العودة إلى الطلبات",
  "orders.backToList": "العودة إلى الطلبات",
  "orders.demoNote": "هذه معاينة ببيانات تجريبية.",

  "orders.detail.customer": "بيانات العميل",
  "orders.detail.customerName": "اسم العميل",
  "orders.detail.phone": "رقم الهاتف",
  "orders.detail.call": "اتصال",
  "orders.detail.orderInfo": "بيانات الطلب",
  "orders.detail.fulfillment": "طريقة الاستلام والتسليم",
  "orders.detail.total": "المبلغ الإجمالي الحالي",
  "orders.detail.status": "الحالة الحالية",
  "orders.detail.priority": "أولوية الطلب",
  "orders.detail.driver": "المندوب",
  "orders.detail.createdAt": "تاريخ الإنشاء",
  "orders.detail.items": "قائمة القطع",
  "orders.detail.itemsCount": "عدد القطع",
  "orders.detail.units": "وحدة",

  "orders.items.type": "نوع القطعة",
  "orders.items.service": "نوع الخدمة",
  "orders.items.qty": "الكمية",

  "orders.amount.title": "تفصيل المبلغ",
  "orders.amount.note": "قيمة القطع محسوبة من أسعار الخدمات المعتمدة، ويُضاف إليها رسوم التوصيل للوصول إلى المبلغ الإجمالي.",
  "orders.amount.unitPrice": "سعر الوحدة",
  "orders.amount.subtotal": "قيمة القطع",
  "orders.amount.deliveryFee": "رسوم التوصيل",
  "orders.amount.total": "المبلغ الإجمالي",
  "orders.amount.unpriced": "تعذّر تسعير بعض القطع بأسعار معتمدة، ويظهر المبلغ الإجمالي كما سجّله النظام.",

  "orders.actions.title": "الإجراءات المتاحة",
  "orders.actions.accept": "قبول الطلب",
  "orders.actions.reject": "رفض الطلب",
  "orders.actions.receive": "تم الاستلام — جاري مراجعة الطلب",
  "orders.actions.startProgress": "قيد التنفيذ",
  "orders.actions.ready": "جاهز للتسليم",
  "orders.actions.assignDriver": "تعيين مندوب تابع",

  "orders.accept.confirm.title": "قبول الطلب؟",
  "orders.accept.confirm.text": "سيتم قبول الطلب وبدء رحلته وفق طريقة الاستلام والتسليم المحددة.",
  "orders.accept.confirm.confirm": "قبول الطلب",
  "orders.reject.confirm.title": "رفض الطلب؟",
  "orders.reject.confirm.text": "سيُلغى الطلب ويُعاد المبلغ للعميل وفق آلية الاسترداد المعتمدة",
  "orders.reject.confirm.confirm": "تأكيد الرفض",
  "orders.receive.confirm.title": "تأكيد الاستلام؟",
  "orders.receive.confirm.text": "هل تم استلام الملابس فعليًا في المغسلة؟",
  "orders.receive.confirm.confirm": "تأكيد الاستلام",
  "orders.ready.confirm.title": "جاهز للتسليم؟",
  "orders.ready.confirm.text": "هل اكتملت الخدمة وأصبح الطلب جاهزًا للتسليم؟",
  "orders.ready.confirm.confirm": "جاهز للتسليم",
  "orders.confirm.cancel": "إلغاء",

  "orders.toast.accepted": "تم قبول الطلب",
  "orders.toast.rejected": "تم رفض الطلب",
  "orders.toast.received": "تم استلام الملابس وبدأت مراجعة محتويات الطلب",
  "orders.toast.reviewAdopted": "تم اعتماد مراجعة محتويات الطلب",
  "orders.toast.started": "تم بدء تنفيذ الطلب",
  "orders.toast.ready": "تم تحديث الطلب إلى جاهز للتسليم",
  "orders.toast.assigned": "تم تعيين المندوب التابع للمهمة",

  "orders.accept.pickupNote": "بدأ النظام بالبحث عن مندوب استلام.",
  "orders.accept.dropoffNote": "بانتظار أن يوصل العميل الملابس إلى المغسلة.",
  "orders.receive.pickupDriverNote": "ورد من النظام أن مندوب الاستلام سلّم الملابس إلى المغسلة.",
  "orders.duration.startsNote": "تبدأ مدة التنفيذ المعتمدة من لحظة استلام المغسلة للطلب فعليًا.",
  "orders.ready.deliveryNote": "بدأ النظام بالبحث عن مندوب تسليم.",
  "orders.ready.pickupNote": "بانتظار أن يستلم العميل الطلب من المغسلة بنفسه.",

  "orders.review.title": "مراجعة محتويات الطلب",
  "orders.review.note": "راجع القطع المستلمة فعليًا وقارنها بالقطع المسجلة في الطلب.",
  "orders.review.recordedType": "نوع القطعة المسجل",
  "orders.review.actualType": "نوع القطعة الفعلي",
  "orders.review.service": "نوع الخدمة",
  "orders.review.serviceLocked": "نوع الخدمة الذي اختاره العميل للعرض فقط.",
  "orders.review.recordedQty": "الكمية المسجلة",
  "orders.review.actualQty": "الكمية الفعلية",
  "orders.review.addedBadge": "قطعة مضافة",
  "orders.review.recordedBadge": "قطعة أصلية",
  "orders.review.addItem": "إضافة قطعة مستلمة",
  "orders.review.addItemServiceNote": "تواصل مع العميل خارجيًا لتحديد الخدمة المطلوبة للقطعة الإضافية، ثم سجّل الخدمة المتفق عليها.",
  "orders.review.selectItem": "اختر نوع القطعة",
  "orders.review.selectService": "اختر نوع الخدمة",
  "orders.review.add": "إضافة",
  "orders.review.remove": "إزالة",
  "orders.review.cancelAdd": "إلغاء",
  "orders.review.summary": "ملخص القطع بعد المراجعة",
  "orders.review.unitsTotal": "إجمالي عدد القطع",
  "orders.review.previousTotal": "المبلغ السابق",
  "orders.review.finalTotal": "المبلغ النهائي المتوقع",
  "orders.review.diff": "فرق المبلغ",
  "orders.review.diffIncrease": "زيادة",
  "orders.review.diffDecrease": "نقص",
  "orders.review.diffNone": "لا تغيير",
  "orders.review.adopt": "اعتماد المراجعة",
  "orders.review.issue.unavailable": "الخدمة المختارة غير متاحة للنوع المصحح لهذه القطعة، وتحتاج معالجة معتمدة.",
  "orders.review.issue.empty": "لا توجد أي قطعة فعلية، وتحتاج هذه الحالة معالجة معتمدة.",
  "orders.review.issue.hint": "عالج النقاط المعلَّمة قبل اعتماد المراجعة.",
  "orders.review.adoptedNote": "تم اعتماد مراجعة محتويات الطلب. يمكنك بدء التنفيذ.",
  "orders.review.itemsReadonlyNote": "القطع المعتمدة أصبحت للعرض فقط.",

  "orders.escalation.title": "يحتاج تعيين مندوب",
  "orders.escalation.text": "اختار العميل الانتظار وانقضت المهلة دون قبول مهمة التسليم. يمكنك تعيين مندوب تابع متاح.",
  "orders.escalation.assign": "تعيين مندوب تابع",
  "orders.escalation.note": "تظل المهمة متاحة للمندوبين بالتوازي حتى يقبلها أحدهم أو تُعيَّن يدويًا.",

  "orders.assign.title": "تعيين مندوب تابع",
  "orders.assign.note": "تُعيَّن المهمة على المندوب التابع إلزاميًا وفق آلية النظام.",
  "orders.assign.available": "المندوبون التابعون المتاحون",
  "orders.assign.phone": "رقم الهاتف",
  "orders.assign.empty": "لا يوجد مندوب تابع متاح حاليًا",
  "orders.assign.emptyHint": "لا يمكن تعيين مندوب مشغول أو غير متاح. حدّث القائمة للمحاولة مجددًا.",
  "orders.assign.refresh": "تحديث القائمة",
  "orders.assign.confirm": "تأكيد التعيين",
  "orders.assign.error": "تعذّر تحميل المندوبين المتاحين",
  "orders.assign.unavailable": "لم تعد المهمة أو المندوب متاحًا. حدّث القائمة ثم حاول مجددًا.",

  "orders.completed.note": "اكتمل استلام الطلب. القطع والمبلغ النهائي للعرض فقط.",
  "orders.cancelled.reason": "سبب الإلغاء",
  "orders.cancelled.refund": "حالة الاسترداد",
  "orders.cancelReason.customer_cancelled": "ألغى العميل الطلب",
  "orders.cancelReason.laundry_rejected": "رفضت المغسلة الطلب",
  "orders.refund.pending": "الاسترداد قيد الانتظار",
  "orders.refund.processing": "الاسترداد قيد المعالجة",
  "orders.refund.completed": "تم الاسترداد",
  "orders.refund.none": "لا يتطلب استردادًا",

  "orders.smartbox.title": "البوكس الذكي",
  "orders.smartbox.stage.pickup": "الاستلام",
  "orders.smartbox.stage.delivery": "التسليم",
  "orders.smartbox.note": "الوصف كما ورد من النظام؛ لا يمكن للمغسلة تغيير طريقة الطلب أو التحكم بالقفل."
};